import { SvgIcon } from "@material-ui/core";

export const Undo = (props) => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.13131 3.66732H5.66927V5.00065H1.0026V0.333984H2.33594V2.51422C3.48601 1.12233 5.13312 0.333984 7.0026 0.333984C10.6845 0.333984 13.6693 3.31875 13.6693 7.00065C13.6693 10.6825 10.6845 13.6673 7.0026 13.6673C3.32071 13.6673 0.335938 10.6825 0.335938 7.00065H1.66927C1.66927 9.94617 4.05709 12.334 7.0026 12.334C9.94812 12.334 12.3359 9.94617 12.3359 7.00065C12.3359 4.05513 9.94812 1.66732 7.0026 1.66732C5.40686 1.66732 4.0383 2.38645 3.13131 3.66732Z" fill="currentColor" />
  </SvgIcon>
)
